import { IAudit, IPermissions, RecipientInformation, TemplateType } from '@alberta/konexi-shared';

import { AuthorizedKiwiInstitution } from '@alberta/konexi-shared/dist/institution/authorized-kiwi-institution';
import { AggregateRoot } from '../aggregate-root';
import { AuditNodeDto } from './audit-node-dto.model';

export class AuditDto extends AggregateRoot implements IAudit {
  completed: boolean;
  templateId: string;
  displayType = 0;

  permissions: IPermissions;

  auditNodes: AuditNodeDto[] = [];

  createdUtc: string;
  createdBy: string;
  updatedUtc: string;
  updatedBy: string;
  patientId: string;
  hash: {
    [nodeId: string]: string;
  };

  type: TemplateType;
  therapyId: number;
  therapyTypeId: number;
  woundLocation: string;
  regionId: string;
  additionalInfo: string;
  createdAt: Date;
  updatedAt: Date;
  emailAddresses: string[];
  optimizedFormularValidation: boolean;
  images: [];
  faxInfo?: RecipientInformation;
  emailInfo?: RecipientInformation;
  draft?: boolean;
  authorizedKiwiInstitutions: AuthorizedKiwiInstitution[];

  constructor() {
    super();
  }

  findNodeByTemplateNodeId(templateNodeId: string): AuditNodeDto {
    return this.findNodeByTemplateNodeIdRec(templateNodeId, this.auditNodes);
  }

  private findNodeByTemplateNodeIdRec(templateNodeId: string, auditNodes: AuditNodeDto[]): AuditNodeDto {
    for (const auditNode of auditNodes) {
      if (auditNode.templateNodeId === templateNodeId) {
        return auditNode;
      }

      if (auditNode.children != null) {
        const result = this.findNodeByTemplateNodeIdRec(templateNodeId, auditNode.children);
        if (result) {
          return result;
        }
      }
    }
  }
}
